import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_LISTING_ARCHIVE,
} from 'api/actionTypes';

export default async function archive({ state, apiClient }, { listingId, notifyApplicants }) {
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('notifyApplicants::Boolean', notifyApplicants);

  await apiClient.postWithState({
    action: SR_API_ACTION_LISTING_ARCHIVE,
    state: state,
    queryId: `${listingId}`,
    payload: {
      listingId,
      notifyApplicants,
    },
  });
}
